import React from 'react';
import styled from 'astroturf/react';
import { Image } from 'js/social/shared/types';
import { PostImage } from 'js/social/shared/PostImage';
import routes from 'sitewide-js/core_pre_webpack/routes';
import _Container from "Base-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Base.tsx?styleId=Container";
import _DesktopQuoteImageOnSide from "Base-DesktopQuoteImageOnSide.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Base.tsx?styleId=DesktopQuoteImageOnSide";
import _HeaderAndContentContainer from "Base-HeaderAndContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Base.tsx?styleId=HeaderAndContentContainer";
import _ImageContainer from "Base-ImageContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Base.tsx?styleId=ImageContainer";
import _DisplayOnMobile from "Base-DisplayOnMobile.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Base.tsx?styleId=DisplayOnMobile";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const DesktopQuoteImageOnSide = /*#__PURE__*/styled("div", null, {
  displayName: "DesktopQuoteImageOnSide",
  styles: _DesktopQuoteImageOnSide
});

const HeaderAndContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "HeaderAndContentContainer",
  styles: _HeaderAndContentContainer
});

const ImageContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ImageContainer",
  styles: _ImageContainer
});

const DisplayOnMobile = /*#__PURE__*/styled("div", null, {
  displayName: "DisplayOnMobile",
  styles: _DisplayOnMobile
});
interface Props {
  className?: string;
  reason?: React.ReactNode;
  header: React.ReactNode;
  content: React.ReactNode;
  cta?: React.ReactNode;
  hoisted?: boolean;
  isQuotedNews?: boolean;
  image?: Image;
  isSinglePostPage?: boolean;
  newsType?: string;
  newsId?: string | number;
  looksDeleted?: boolean;
  nested?: boolean;
}

const Base: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  reason,
  header,
  content,
  cta,
  children,
  hoisted,
  isQuotedNews,
  image,
  isSinglePostPage,
  newsType,
  newsId,
  looksDeleted,
  nested = false,
}) => {
  const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // !event.target.classList.contains('clickable');
    const target = event.target as HTMLElement;
    if (
      isQuotedNews &&
      target.tagName !== 'A' &&
      // adding 'clickable' to the bottom level of className for
      // (e.g. '...see more' and images) prevents redirect
      !target.classList.contains('clickable') &&
      // prevent lightbox popover clicks from redirecting to single
      // post page
      !target.className.startsWith('yarl')
    ) {
      window.location.href =
        newsType === 'post'
          ? routes.community_show_post_url({ post_id: newsId })
          : routes.community_show_paper_update_url({
              paper_update_id: newsId,
            });
    }
  };
  return (
    <Container
      className={className}
      hoisted={hoisted}
      quoted={isQuotedNews}
      nested={nested}
      onClick={handleContainerClick}
    >
      {reason}
      {isQuotedNews && !isSinglePostPage && !looksDeleted && image ? (
        <>
          <DesktopQuoteImageOnSide>
            <HeaderAndContentContainer>
              {header}
              {content}
            </HeaderAndContentContainer>
            <ImageContainer>
              <PostImage image={image} />
            </ImageContainer>
          </DesktopQuoteImageOnSide>
          <DisplayOnMobile>
            {header}
            {content}
          </DisplayOnMobile>
        </>
      ) : (
        <>
          {header}
          {content}
        </>
      )}
      {cta}
      {children}
    </Container>
  );
};

export default Base;
